import styled from 'styled-components';

export const InfiosButtonAuthorable = styled.section`
    display:flex;
    justify-content: ${props => props.alignment || 'center'};
    button {
        white-space: normal;
        max-height: unset;

        &.tertiary {
            padding: 16px 0;
        }
    }
`;
